import { useChatStore } from '@/stores/chat'
import useChat from '@/composables/chat/useChat'

const store = useChatStore()

const workerPath = import.meta.env.VITE_WORKER_PATH
export let worker = new Worker(workerPath, { type: 'module' })

/**
 * @param {String} path
 * @param {String} token
 * @param {Boolean} force
 * @deprecated
 */
export const startWebsocket = (path, token, force = false) => {
    let url = `${path}?token=${token}`

    if (force) url += '&force=true'

    console.log({ type: 'wsInit', data: { url } })
    worker.postMessage({ type: 'wsInit', data: { url } })
}

/** @param {Object} e */
worker.onmessage = e => {
    const { type, data } = e.data
    
    if (type === 'wsMessage') {


        useChat.dispatch(data)
    } else if (type === 'wsConnection') {
        store().updateWebsocketStatus(data.status)
    }
}
